import React, { useEffect, useState } from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Label
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SelectableListModal({
  isOpen,
  title,
  items,
  helpMessage,
  renderItem,
  getItemId = (item) => item.id,
  onCancel,
  onConfirm
}) {
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    if (isOpen && items.length > 0) {
      setSelectedId(getItemId(items[0]));
    }
  }, [isOpen, items, getItemId]);

  const selectedItem = items.find((item) => getItemId(item) === selectedId);

  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader
        toggle={onCancel}
        close={
          <FontAwesomeIcon
            color="black"
            icon="times"
            size="2x"
            onClick={onCancel}
          />
        }
      >
        {title}
      </ModalHeader>
      <ModalBody style={{ maxHeight: "300px", overflowY: "auto" }}>
        <Label className="fw-semibold mb-3">Select an Option</Label>
        <div className="d-flex flex-column" style={{ gap: "0.3rem" }}>
          {items.map((item) => {
            const id = getItemId(item);
            return (
              <div
                key={id}
                onClick={() => setSelectedId(id)}
                style={{
                  border: selectedId === id ? "2px solid #0d6efd" : "1px solid #ddd",
                  borderRadius: "0.5rem",
                  padding: "0.75rem 1rem",
                  cursor: "pointer",
                  textAlign: "center",
                  transition: "border-color 0.2s",
                }}
              >
                {renderItem(item)}
              </div>
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="asterisk-help">
            <div>{helpMessage}</div>
          </div>
          <div className="mt-2 d-flex justify-content-end">
            <Button color="secondary" onClick={onCancel} style={{ marginRight: "1rem" }}>
              Cancel
            </Button>
            <Button color="primary" onClick={() => onConfirm(selectedItem)} disabled={!selectedItem}>
              OK
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default SelectableListModal;